var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalyticsStepDownArraowRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4416 17.8548H0.425781V18.8455H16.4416V17.8548Z",
    fill: "#F24545"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0715 12.262L14.1053 12.4811L14.4605 14.0475L8.18728 10.0934L9.80593 7.52543L1.68305 2.40538L1.15482 3.2434L8.43961 7.83524L6.82093 10.4032L13.9323 14.8856L12.3658 15.2408L12.5849 16.2069L15.8006 15.4778L15.0715 12.262Z",
    fill: "#F24545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsStepDownArraowRed);
export default __webpack_public_path__ + "static/media/analyticsStepDownArraowRed.87d2ed5b15c81ca8eee92fc6e0d479f1.svg";
export { ForwardRef as ReactComponent };